module.exports = __webpack_public_path__ + "img/profAsses.0072aa85.svg";